import { render, staticRenderFns } from "./SendToEmail.vue?vue&type=template&id=b92322a2&"
import script from "./SendToEmail.vue?vue&type=script&lang=js&"
export * from "./SendToEmail.vue?vue&type=script&lang=js&"
import style0 from "./SendToEmail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports